export enum HttpContentType {
  ApplicationJson = 'application/json',
  ApplicationOctetStream = 'application/octet-stream',
  ApplicationXWwwFormUrlencoded = 'application/x-www-form-urlencoded',
  MultipartFormData = 'multipart/form-data',
}
